import { faMagnifyingGlass, faSliders } from '@fortawesome/free-solid-svg-icons'
import "./Task_income_cards_section.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect, useRef } from 'react'
import { Form, InputGroup, Accordion, Button } from 'react-bootstrap'
import File_animation from '../../../../animations/file_animation/File_animation'
import Task_income_cards from './task_income_cards/Task_income_cards'

function Task_income_cards_section() {
    const [modalShow, setModalShow] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);

    const filterRef = useRef(null);

    // 👉 Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            if (filterRef.current && !filterRef.current.contains(e.target)) {
                setFilterOpen(false);
            }
        }

        if (filterOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [filterOpen]);

    // 👉 Close when clicking Apply
    const handleApply = () => {
        setFilterOpen(false);
    };

    return (
        <>
            <section className='Task_income_cards_section' style={{ position: "relative" }}>
                
                {/* 🔍 Search Bar */}
                <div className="search_bar_hodler">
                    <div className="search_fiels_holder">
                        <InputGroup>
                            <Form.Control placeholder="Search Task" />
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </InputGroup.Text>
                        </InputGroup>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <div className="file_icon_holder" onClick={() => setModalShow(true)}>
                            <File_animation />
                        </div>

                        <div
                            className="file_icon_holder slider_icon"
                            onClick={() => setFilterOpen(!filterOpen)}
                        >
                            <FontAwesomeIcon icon={faSliders} />
                        </div>
                    </div>
                </div>

                {/* 👉 Right Slide Dropdown Filter */}
                <div ref={filterRef} className={`filter_dropdown ${filterOpen ? 'open' : ''}`}>
                    <Accordion>
                        {/* STATUS FILTER */}
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Status</Accordion.Header>
                            <Accordion.Body>
                                <Form.Check id="status-completed" type="checkbox" label="Completed" />
                                <Form.Check id="status-pending" type="checkbox" label="Pending" />
                                <Form.Check id="status-rejected" type="checkbox" label="Rejected" />
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* SORT FILTER */}
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Sort By</Accordion.Header>
                            <Accordion.Body>
                                <Form.Check id="sort-newest" type="radio" name="sort" label="Newest" />
                                <Form.Check id="sort-oldest" type="radio" name="sort" label="Oldest" />
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* TASK TYPE FILTER */}
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Task Type</Accordion.Header>
                            <Accordion.Body>
                                <Form.Check id="task-survey" type="checkbox" label="Survey" />
                                <Form.Check id="task-download" type="checkbox" label="Download" />
                                <Form.Check id="task-watch" type="checkbox" label="Watch Video" />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    {/* APPLY BUTTON */}
                    <div className="btn_holder">
                        <Button className="apply_btn" onClick={handleApply}>Apply</Button>
                    </div>
                </div>

                {/* TASK CARDS */}
                <Task_income_cards />
                <Task_income_cards />
                <Task_income_cards />
                <Task_income_cards />

            </section>
        </>
    )
}

export default Task_income_cards_section
